export default __webpack_public_path__ + "static/media/password-icon.b0098582.svg";